const UploadModules = {

    NEWS: 0,

    TESTIMONIAL: 1,

    GALLERY: 2,

    SLIDER: 3,

    TEAM: 4,

    CLIENT: 5,

    AWARD: 6,

    EVENT: 7,

    DOWNLOAD: 8,

    VIDEO: 9

};

export default UploadModules;